export const en = {
    found: 'Found',
    of: 'out of',
    selected: 'Selected'
};
